import { Injectable, ComponentRef, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OverlayService {
    private overlayRef: OverlayRef;

    private displaySubject = new BehaviorSubject<{ status: boolean, component: ComponentType<unknown> | null, viewContainerRef: ViewContainerRef }>({ status: false, component: null, viewContainerRef: null });
    displayObservable = this.displaySubject.asObservable();

    constructor(private overlay: Overlay) { }

    open(data: { component?: ComponentType<unknown> | null, viewContainerRef?: ViewContainerRef, data?: any }): ComponentRef<any> {
        // Si ya hay un overlay abierto, lo cerramos
        if (this.overlayRef) {
            this.overlayRef.detach();
        }
    
        const overlayConfig = new OverlayConfig({
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-transparent-backdrop',
            positionStrategy: this.overlay.position()
                .global()
                .centerHorizontally()
                .centerVertically()
        });
    
        this.overlayRef = this.overlay.create(overlayConfig);
    
        // Cerramos el overlay al hacer clic en el backdrop
        this.overlayRef.backdropClick().subscribe(() => this.close());
    
        // Crea el portal del componente
        const componentPortal = data.component ? new ComponentPortal(data.component, data.viewContainerRef) : null;
    
        if (!componentPortal) {
            console.error('ComponentPortal not found.');
            return null;
        }
    
        const componentRef = this.overlayRef.attach(componentPortal);
    
        // Pasar datos al componente cargado
        if (data.data && componentRef.instance) {
            Object.assign(componentRef.instance, data.data);
        }
    
        this.displaySubject.next({ status: true, component: data.component, viewContainerRef: data.viewContainerRef });
        return componentRef;
    }
    

    close() {
        if (this.overlayRef) {
            this.displaySubject.next({ status: false, component: null, viewContainerRef: null });
            this.overlayRef.detach();
            this.overlayRef = null;
        }
    }
}
